import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'
import clsx from 'clsx'

import { Card } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme) =>
  createStyles({
    outerWrapper: {
      position: 'relative',
      marginBottom: '36px',
      padding: '48px 22px 12px 22px',
      borderColor: 'transparent',
      backgroundColor: theme.colors.grey200,
    },
    circularProgress: {
      position: 'absolute',
      top: 'calc(50% - 30px)',
      left: 'calc(50% - 30px)',
    },
    innerWrapper: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
    },
    visibilityHidden: {
      visibility: 'hidden',
    },
    img: {
      width: '100%',
      maxWidth: '277px',
      marginBottom: '20px',
    },
    text: {
      fontSize: '14px',
      color: theme.colors.grey480,
      marginBottom: '24px',
    },
  }),
)

type ReputationProp = {
  isLoading: boolean
  imgSrc: string
  imgAlt: string
  score: string
  description: string
}

export const Reputation: FC<ReputationProp> = ({
  imgSrc,
  imgAlt,
  score = 'X',
  description,
  isLoading,
}) => {
  const classes = useStyles()

  return (
    <Card className={classes.outerWrapper}>
      {isLoading && (
        <CircularProgress size="60px" className={classes.circularProgress} />
      )}
      <div
        className={clsx(
          classes.innerWrapper,
          isLoading && classes.visibilityHidden,
        )}
      >
        <img className={classes.img} src={imgSrc} alt={imgAlt} />
        <p className={classes.text}>
          <b>Score</b> = {score} out of 5 stars
        </p>
        <p className={classes.text}>{description}</p>
      </div>
    </Card>
  )
}
